import { version } from '@environments/version';

export const environment = {
  PRODUCTION: true,
  APP_VERSION: version,
  STAGE: 'production',

  CACHE_LIFETIME: 300000,
  NOTIFICATIONS_CACHE_LIFETIME: 20000,
  SESSION_ACTIVITY_MINUTES: 15,

  // PORTAL_API for Notification and Identity
  PORTAL_API: 'https://api.portal.cxc.com.mx',
  // FACILITIES_API for Operations TODO
  FACILITIES_API: 'https://api.suite.cxc.com.mx',
  COMPANIES_API: 'https://api.suite.cxc.com.mx',

  FACILITIES_API_KEY: 'A1b2C3d4E5f6G7h8I9j0K1l2M3n4O5p6Q7r',
  FINANCIALS_API_KEY: 'A1b2C3d4E5f6G7h8I9j0K1l2M3n4O5p6Q7r',
  COMPANIES_API_KEY: 'A1b2C3d4E5f6G7h8I9j0K1l2M3n4O5p6Q7r',
  DATA_STUDIO_API_KEY: 'A1b2C3d4E5f6G7h8I9j0K1l2M3n4O5p6Q7r',
  // LEN-2764: false once this environment's load balancer enforces the
  // JWT-shaped Bearer rule (920); then the browser stops sending the key.
  SEND_EDGE_API_KEY: true,

  REMOTE_URL_RUG: 'https://rug.suite.cxc.com.mx',
  REMOTE_URL_AIVA: 'https://aiva-ui-prod.web.app',
  REMOTE_URL_COMPANY: 'https://companies.suite.cxc.com.mx',
  REMOTE_URL_FINANCIAL: 'https://financials.suite.cxc.com.mx',
  REMOTE_URL_DATA_STUDIO: 'https://data-studio.suite.cxc.com.mx',
  REMOTE_URL_SHELL_ADMIN: 'https://shell-admin.suite.cxc.com.mx',
  // Embedded DocFlow AI. Must be served without IAP (LEN-2400) or the iframe falls back to "not available"
  DOCFLOW_URL: 'https://prod.docflow.ai.cxc.com.mx',

  SENTRY_DSN:
    'https://5066bcb22a8b89236353618dfb9ba751@o4504160456474624.ingest.us.sentry.io/4509158904758272',

  PENDO_API_KEY: '2322acbd-8edd-49d0-a34b-7013baf148c3',
  PENDO_ENV: 'io',
  PENDO_DEBUG: false,
  ENABLE_PENDO: true,
};
